import { createContext } from "react"

const UserContext = createContext({
    loggedInUser: 'Neha'
});

export default UserContext;